import React, { useState, useRef, useEffect, useContext } from "react";
import NextRouter from "next/router";
import api from "components/settings/api";

import PropTypes from "prop-types";
import ModalErrorHandler from "./ModalErrorHandler";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import { toast, Bounce } from "react-toastify";
import CustomToastMessage from "components/common/CustomToastMessage";
import { makeStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Avatar from "@mui/material/Avatar";
import TeamStatusSelector from "components/common/TeamStatusSelector";
import TeamPlan from "components/modals/TeamUpgrade/TeamPlan";
import TeamPlanSelector from "components/common/TeamPlanSelector";
import AskUser from "components/modals/TeamUpgrade/Ask";
import { GlobalContext } from "components/context/GlobalContext";
const useStyles = makeStyles((theme) => ({
  modalWrapper: {
    position: "fixed",
    placeContent: "center",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: "100%",
    height: "100%",
    overflow: "auto",
    zIndex: "1000",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#00000098",
    paddingRight: 17,
    "@media screen and (maxWidth: 700)": {
      placeContent: "flex-start",
    },
  },
  containerInner: {
    padding: "20px",
    width: "100%",
    "@media screen and (max-width: 500px)": {
      padding: "0 16px",
    },
    gap: "10px",
  },
  paper: {
    borderRadius: "5px",
    boxShadow: "2.5px 5px #464646",
    maxWidth: "500px",
  },

  avatarDiv: {
    display: "flex",
    placeContent: "center",
  },
  avatar: {
    backgroundColor: "#2eb790",
    height: "100px",
    width: "100px",
    color: "#ffffff",
    fontSize: "48px",
    cursor: "pointer",
  },
  avatarIcon: {
    fontSize: 42,
    marginRight: 4,
  },
  title: {
    fontFamily: "Poppins",
    fontWeight: 700,
    fontSize: "24px",
    marginTop: "1rem",
  },
  subtitle: {
    fontFamily: "Open Sans",
    fontWeight: "normal",
    fontSize: 14,
    margin: "0 1rem",
    lineHeight: "150%",
    color: "rgba(0, 27, 17, 0.5)",
  },
  sub_title: {
    margin: "0 1rem",
  },
  centeredTitle: {
    width: "100%",
    textAlign: "center",
    marginBottom: theme.spacing(1),
  },
  selector: {
    width: "100%",
  },
  team_privacy: {},
  checkbox: {
    fontFamily: "Open Sans",
    fontWeight: "normal",
    fontSize: 14,
    lineHeight: "150%",
    color: "#07b97e",
  },
  buttons: {
    color: "white",
    fontFamily: "open sans",
    minWidth: "10rem",
    backgroundColor: theme.palette.primary.main,
    margin: "1rem .5rem",
  },
  radioGroup: {
    margin: theme.spacing(1, 0),
  },
  radioButton: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  radioLabel: {
    display: "flex",
    alignItems: "center",
  },
  label: {
    fontFamily: "Open Sans",
    margin: theme.spacing(0, 1),
    fontWeight: "normal",
    fontSize: 14,
  },
  popover: {
    pointerEvents: "none",
  },
  newpaper: {
    backgroundColor: "#2eb790",
    margin: theme.spacing(4),
    padding: theme.spacing(3),
    color: "ghostwhite",
  },
}));

const NewTeam = ({ toggleModal, isOrganization }) => {
  const classes = useStyles();

  const [openUpgrade, setOpenUpgrade] = useState(false);
  const [ask, setAsk] = useState(false);
  const [premiumPlan, setPremiumPlan] = useState(false);
  const [organizationPlan, setOrganizationPlan] = useState(false);
  const { setNavTeamCredits, toggleTokenMenu } = useContext(GlobalContext);

  const initialTeamData = {
    title: "",
    mission: "",
    status: "Open invitation",
    plan: { value: "Basic", label: "Basic (10 members)", cost: 0 },
  };

  const options = [
    {
      value: "Open Invitation",
      label: "Open Invitation",
      tooltipContent:
        "Anybody can join the team without applying. There is a Join button on the team page. It makes it more like a group.",
    },
    {
      value: "Accepting Applications",
      label: "Accepting Applications",
      tooltipContent:
        "People can apply to join the team, but the team manager will decide to approve or reject each application. There is an apply button on the team page.",
    },
    {
      value: "Closed to Applications",
      label: "Closed to Applications",
      tooltipContent:
        "People cannot apply to join the team, but they still can see the team managers and mission.",
    },
  ];

  const optionsTeamPlan = [
    { value: "basic", label: "Basic (10 members) - 6 tokens" },
    { value: "premium", label: "Premium (100 members) - 20 tokens" },
    { value: "organization", label: "Organization (300 members) - 70 tokens" },
  ];

  // Ask user are they want to upgrade
  const openAskPremium = () => {
    setAsk(true);
    setPremiumPlan(true);
    setOrganizationPlan(false);
  };

  const openAskOrganization = () => {
    setAsk(true);
    setOrganizationPlan(true);
    setPremiumPlan(false);
  };

  const [{ title, mission, status, plan }, setTeamData] =
    useState(initialTeamData);
  const [imageSelected, setImageSelected] = useState("");
  const [showErrors, setShowErrors] = useState(false);
  const [errorsArr, setErrorsArr] = useState();
  const [selectedPlan, setSelectedPlan] = useState("");

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setTeamData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSelectChange = (element) => {
    const { value } = element;
    setTeamData((prevState) => ({
      ...prevState,
      status: value,
    }));
  };

  const handlePlanChange = (selectedPlan) => {
    const tokenCosts = { basic: 0, premium: 14, organization: 64 };
    const hasTokens = userTokenBalance >= tokenCosts[selectedPlan.value];

    setTeamData((prevState) => ({
      ...prevState,
      plan: selectedPlan,
    }));
    setHasEnoughTokens(hasTokens);
  };

  const upgradeTeam = async () => {
    setAsk(false); // Close the AskUser modal
    createTeam(); // Proceed to create the team
  };

  const [userTokenBalance, setUserTokenBalance] = useState(0);
  const [hasEnoughTokens, setHasEnoughTokens] = useState(true);

  // Function to fetch and set the user's token balance
  const fetchUserTokenBalance = async () => {
    try {
      const response = await api.get("/api/v1/teams/credits"); // Update this endpoint as needed
      if (response && response.data) {
        setUserTokenBalance(response.data.tokenBalance);
      }
    } catch (error) {
      console.error("Error fetching token balance:", error);
    }
  };

  // Call this function when component mounts or user info is updated
  useEffect(() => {
    fetchUserTokenBalance();
    if (isOrganization) {
      setTeamData((prevState) => ({
        ...prevState,
        plan: { value: "organization", label: "Organization (300 members)" },
      }));
    }
  }, []);

  // Toast message function
  const notify = (message) =>
    toast.info(<CustomToastMessage message={message} />, {
      autoClose: 2000,
      closeButton: true,
      hideProgressBar: false,
      transition: Bounce,
      position: "bottom-center",
    });

  const createTeam = async () => {
    let payload = {
      title,
      mission,
      status,
      plan: plan.value,
    };

    // If an image is selected, append it to the payload
    if (imageSelected) {
      const formData = new FormData();
      formData.append("file", imageSelected.raw);
      try {
        const pictureResponse = await api.post(
          "/api/v1/teams/upload/image",
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        payload.teamAvatar = pictureResponse.data.data.imageUrl;
      } catch (uploadError) {
        console.error("Error uploading image:", uploadError);
        return; // Stop the function if image upload fails
      }
    }

    try {
      const response = await api.post("/api/v1/teams/team", payload);

      if (response.data.validationErrors === undefined) {
        // Assuming the response contains the ID of the created team
        const teamId = response.data.public_team_id;
        notify("Team created successfully!");

        // Close the modal and redirect to the newly created team's page
        toggleModal();
        NextRouter.push(`/team/${teamId}`);
      } else {
        // Handle validation errors if any
        setErrorsArr(response.data.validationErrors.errors);
        setShowErrors(true);
      }
    } catch (error) {
      console.error("Error during team creation:", error);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Example token costs for different plans
    const tokenCosts = { basic: 0, premium: 20, organization: 70 };

    // Check if user has enough tokens
    if (plan.value !== 'basic' && userTokenBalance < tokenCosts[plan.value]) {
        notify("Not enough tokens to create this type of team.");
        toggleTokenMenu();
        return; // Exit the function early
    }

    createTeam();

    // Only show AskUser modal if the user has enough tokens
    // if (plan.value === "premium" || plan.value === "organization") {
    //   setAsk(true);
    //   setPremiumPlan(plan.value === "premium");
    //   setOrganizationPlan(plan.value === "organization");
    // } else {
    //   createTeam();
    // }
  };

  const inputFile = useRef(null);
  const onButtonClick = () => {
    inputFile.current.click();
  };

  const handleChange = (e) => {
    if (e.target.files.length) {
      setImageSelected({
        preview: URL.createObjectURL(e.target.files[0]),
        raw: e.target.files[0],
      });
    }
  };

  const tokenCostsCheck = { basic: 0, premium: 14, organization: 64 };

  return (
    <div className={classes.modalWrapper}>
      <Paper variant="outlined" className={classes.paper}>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <Grid item xxs={12}>
            <Grid container justifyContent="center" alignItems="center">
              <Grid item>
                <div className={classes.title} aria-label="Create a new team">
                  Create a New Team
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Button
            disableRipple={false}
            variant="text"
            className="button--modal_cancelJob"
            aria-label="Close modal"
            onClick={toggleModal}
            sx={{ position: "absolute" }}
          >
            <CloseRoundedIcon fontSize="inherit" color="inherit" />
          </Button>
        </Grid>
        {/* From upload avatar to 'Create Team' button */}
        <Grid
          className={classes.containerInner}
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <input
            type="file"
            className="team--modal_upload_avatar"
            ref={inputFile}
            onChange={handleChange}
            aria-label="Upload avatar"
          />
          <Grid item xs={12} className={classes.avatarDiv}>
            <Avatar
              aria-label="team"
              className={classes.avatar}
              component="div"
              onClick={onButtonClick}
              src={imageSelected.preview}
            >
              <AddAPhotoIcon className={classes.avatarIcon} />
            </Avatar>
          </Grid>
          <Grid item xs={12}>
            <Grid container direction="column">
              <form
                className="form--modal_form"
                onSubmit={handleSubmit}
                method="POST"
                style={{ rowGap: 0, gridRowGap: 0 }}
                aria-label="Create Team"
              >
                {showErrors && <ModalErrorHandler errorsArr={errorsArr} />}
                <label className="label--form_label" htmlFor="title">
                  <input
                    className="input input--form_input new_team-modal"
                    type="text"
                    name="title"
                    value={title}
                    minLength="1"
                    maxLength="40"
                    onChange={handleInputChange}
                    required
                    placeholder="Team Title"
                    aria-label="Team Title"
                  />
                </label>
                <label className="label--form_label" htmlFor="mission">
                  <textarea
                    className="input input--form_input new_team-modal"
                    type="textarea"
                    rows="5"
                    name="mission"
                    minLength="1"
                    maxLength="200"
                    id="teamMission"
                    value={mission}
                    onChange={handleInputChange}
                    required
                    placeholder="Team Mission"
                    aria-label="Team Mission"
                  />
                </label>
                <div className={classes.sub_title}>
                  <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Grid
                      item
                      xs={12}
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <div className={classes.title}>Team Privacy Settings</div>
                      <div className={classes.subtitle}>
                        Don&apos;t worry. You can change these settings later.
                      </div>
                      <div
                        style={{ margin: "0 1rem" }}
                        className="team-summary-editor-item"
                      >
                        <div
                          style={{ marginTop: "1rem", marginRight: "1rem" }}
                          className="team-summary-editor-item-content"
                        >
                          <TeamStatusSelector
                            onChange={handleSelectChange}
                            options={options}
                            defaultValue=""
                          />
                        </div>
                      </div>
                      <div
                        style={{ margin: "0 1rem" }}
                        className="team-summary-editor-item"
                      >
                        <div
                          style={{ marginTop: "1rem", marginRight: "1rem" }}
                          className="team-summary-editor-item-content"
                        >
                          {/* Team Plan Title and Selector */}
                          <Grid item xs={12} className={classes.centeredTitle}>
                            <div className={classes.title}>Team Plan</div>
                          </Grid>
                          <TeamPlanSelector
                            className={classes.selector}
                            onChange={handlePlanChange}
                            options={optionsTeamPlan}
                            value={plan}
                          />
                          {!hasEnoughTokens && (
                            <p style={{ color: "red", paddingTop: "10px" }}>
                              Not enough tokens to create this type of team.
                            </p>
                          )}
                        </div>
                      </div>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <p style={{ paddingTop: "15px" }}>
                        {plan.value === "basic" &&
                          "You are creating a Basic team. It costs 6 tokens."}
                        {plan.value === "premium" &&
                          "You are creating a Premium team. It costs 20 tokens."}
                        {plan.value === "organization" &&
                          "You are creating an Organization. It costs 70 tokens."}
                      </p>
                    </Grid>

                    {/* <Grid
                      item
                      xs={12}
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                    >

                      
                      <p style={{ paddingTop: "15px", color: "red" }}>
                        {plan.value === 'basic' && "You are creating a Basic team. It costs 6 tokens."}
                        {plan.value === 'premium' && "You are creating a Premium team. It costs 14 tokens."}
                        {plan.value === 'organization' && "You are creating an Organization. It costs 64 tokens."}
                      </p>
                    </Grid> */}

                    <Grid item>
                      <Button
                        type="submit"
                        value="Create Team"
                        variant="contained"
                        color="primary"
                        className={classes.buttons}
                        aria-label="Create team"
                        // disabled={!hasEnoughTokens}
                      >
                        Create Team
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              </form>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      <AskUser
        ask={ask}
        setAsk={setAsk}
        upgradeTeam={upgradeTeam}
        premiumPlan={premiumPlan}
        organizationPlan={organizationPlan}
      />
    </div>
  );
};

export default NewTeam;

NewTeam.propTypes = {
  toggleModal: PropTypes.func,
};
